import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row ml-3" }
const _hoisted_2 = { class: "col-lg-3 col-md-6 col-sm-12" }
const _hoisted_3 = { class: "col-lg-3 col-md-6 col-sm-12" }
const _hoisted_4 = { class: "col-lg-3 col-md-6 col-sm-12" }
const _hoisted_5 = { class: "row ml-3 mt-1" }
const _hoisted_6 = { class: "col-lg-3 col-md-6 col-sm-12" }
const _hoisted_7 = { class: "col-lg-3 col-md-6 col-sm-12" }
const _hoisted_8 = { class: "row ml-3" }
const _hoisted_9 = { class: "col-lg-3 col-md-6 col-sm-12" }
const _hoisted_10 = { class: "col-lg-3 col-md-6 col-sm-12" }
const _hoisted_11 = { class: "col-lg-3 col-md-6 col-sm-12" }
const _hoisted_12 = { class: "row ml-3" }
const _hoisted_13 = { class: "col-lg-3 col-md-6 col-sm-12" }
const _hoisted_14 = { class: "col-lg-3 col-md-6 col-sm-12" }
const _hoisted_15 = { class: "row ml-3" }
const _hoisted_16 = { class: "col-lg-1 col-md-2 col-sm-3" }
const _hoisted_17 = { class: "col-lg-11 col-md-10 col-sm-9" }
const _hoisted_18 = { class: "col-lg-3 col-md-6 col-sm-12" }
const _hoisted_19 = { class: "row ml-3" }
const _hoisted_20 = { class: "col-lg-3 col-md-6 col-sm-12" }
const _hoisted_21 = { class: "col-lg-3 col-md-6 col-sm-12" }
const _hoisted_22 = { class: "col-lg-3 col-md-6 col-sm-12" }
const _hoisted_23 = { class: "col-lg-3 col-md-6 col-sm-12" }
const _hoisted_24 = { class: "row ml-3 mt-2" }
const _hoisted_25 = { class: "col-lg-2 col-md-4 col-sm-12" }
const _hoisted_26 = { class: "col-lg-10 col-md-8 col-sm-12" }
const _hoisted_27 = { class: "row ml-3" }
const _hoisted_28 = { class: "col-lg-3 col-md-6 col-sm-12" }
const _hoisted_29 = { class: "col-lg-3 col-md-6 col-sm-12" }
const _hoisted_30 = { class: "col-lg-3 col-md-6 col-sm-12" }
const _hoisted_31 = { class: "col-lg-3 col-md-6 col-sm-12" }
const _hoisted_32 = { class: "row ml-3" }
const _hoisted_33 = { class: "col-lg-3 col-md-6 col-sm-12" }
const _hoisted_34 = { class: "col-lg-3 col-md-6 col-sm-12" }
const _hoisted_35 = { class: "col-lg-3 col-md-6 col-sm-12" }
const _hoisted_36 = { class: "row mt-5 text-center" }
const _hoisted_37 = { class: "col-12" }

import { computed, onMounted, ref, toRefs } from 'vue';
import BaseCheckbox from '@/components/base/BaseCheckbox.vue';
import BaseInput from '@/components/base/BaseInput.vue';
import { requiredRule } from '@/shared/validators/validationRules';
import useVuelidate from '@vuelidate/core';
import { useI18n } from 'vue-i18n';
import unemployedPrivateCoachingService from '@/api/Unemployed/PrivateCoaching/index';
import { ErrorToast, SuccessToast } from '@/components/VueToast';
import SaveButton from '@/components/button/SaveButton.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'SelectionInterviewForm',
  props: {
  documentId: {
    type: String,
    required: true,
  },
  submitForm: {
    type: Boolean,
    required: true,
    default: false,
  },
},
  emits: ['update:submitForm'],
  setup(__props, { emit: __emit }) {

const props = __props;

const documentId = toRefs(props)['documentId'];
const { t } = useI18n();
const otherOperationTypeDisabled = ref(true);
const isSubmitting = ref(false);

const emit = __emit;

const formData = ref<any>({
  a1Beginner: false,
  a1BeginnerPrevKnowledge: false,
  b1Intermediate: false,
  b2Advanced: false,
  languageLevelC1AndBetter: false,

  graduationSecondarySchools: false,
  graduationSecondarySchools2: false,
  graduationHighSchoolDiploma: false,
  graduationOther: false,
  graduationWithoutDegree: false,

  completedVocationalTrainingYes: false,
  jobTitle: '',
  completedVocationalTrainingNo: false,

  fcOperationType: false,
  micOperationType: false,
  compassOperationType: false,
  goWorkOperationType: false,
  othersOperationType: false,
  othersOperationTypeDescription: '',

  specialistCoachingPsychologically: false,
  specialistCoachingHealthWise: false,
  specialistCoachingSocial: false,
  specialistCoachingProfessionally: false,

  digitalCompetenceSmartphone: false,
  digitalCompetenceLaptopPc: false,
  digitalCompetenceNoDeviceAvailable: false,
});

const rules = ref({});
const computedRules = computed(() => rules.value);
const v$ = useVuelidate(computedRules, formData);

async function submitForm() {
  v$.value.$touch();
  if (v$.value.$invalid) {
    return;
  }

  try {
    await unemployedPrivateCoachingService.saveSelectionInterview(documentId.value, formData.value);

    isSubmitting.value = false;
    emit('update:submitForm', !props.submitForm);
    SuccessToast(t('general.toasts.save_success'));
  } catch (error) {
    await ErrorToast(error);
  } finally {
    isSubmitting.value = false;
  }
}

async function getDocumentData() {
  try {
    const { data } = await unemployedPrivateCoachingService.getSelectionInterview(documentId.value);
    formData.value = { ...data.data};
  } catch (error) {
    await ErrorToast(error);
  }
}

function onChangeOthersOperationType(value: boolean) {
  formData.value.othersOperationTypeDescription = '';
  if (value) {
    rules.value = {
      ...rules.value,
      othersOperationTypeDescription: requiredRule(t)
    };
    otherOperationTypeDisabled.value = false;
  } else {
    rules.value = {
      ...rules.value,
      othersOperationTypeDescription: '',
    };
    otherOperationTypeDisabled.value = true;
  }
}

onMounted(async () => {
  await getDocumentData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _withModifiers(submitForm, ["prevent"])
  }, [
    _cache[26] || (_cache[26] = _createElementVNode("div", { class: "row" }, [
      _createElementVNode("h6", { class: "mb-2 text-uppercase pl-3" }, "beiMigrationshintergrund: Sprachniveau Deutsch")
    ], -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.a1Beginner,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.a1Beginner) = $event)),
          label: "A1 Beginner",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.a1BeginnerPrevKnowledge,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.a1BeginnerPrevKnowledge) = $event)),
          label: "A1 Beginner (mit Vorkenntnissen)",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.b1Intermediate,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.b1Intermediate) = $event)),
          label: "B1 Intermediate",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.b2Advanced,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.b2Advanced) = $event)),
          label: "B2 Intermediate",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.languageLevelC1AndBetter,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.languageLevelC1AndBetter) = $event)),
          label: "C1 und besser",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _cache[27] || (_cache[27] = _createElementVNode("div", { class: "row mt-4" }, [
      _createElementVNode("h6", { class: "mb-2 text-uppercase pl-3" }, "Schulabschluss:")
    ], -1)),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.graduationSecondarySchools,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.graduationSecondarySchools) = $event)),
          label: "Hauptschule",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.graduationSecondarySchools2,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.graduationSecondarySchools2) = $event)),
          label: "Realschule",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.graduationHighSchoolDiploma,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.graduationHighSchoolDiploma) = $event)),
          label: "Abitur",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.graduationOther,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.value.graduationOther) = $event)),
          label: "Sonstige",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.graduationWithoutDegree,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formData.value.graduationWithoutDegree) = $event)),
          label: "Ohne Abschluss",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _cache[28] || (_cache[28] = _createElementVNode("div", { class: "row mt-4" }, [
      _createElementVNode("h6", { class: "mb-2 text-uppercase pl-3" }, "Abgeschlossene Berufsausbildung/Studium:")
    ], -1)),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.completedVocationalTrainingYes,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formData.value.completedVocationalTrainingYes) = $event)),
          label: "Ja",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formData.value.jobTitle) = $event)),
          placeholder: "Jobtitel",
          class: "form-control"
        }, null, 512), [
          [_vModelText, formData.value.jobTitle]
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.completedVocationalTrainingNo,
          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((formData.value.completedVocationalTrainingNo) = $event)),
          label: "Nein",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _cache[29] || (_cache[29] = _createElementVNode("div", { class: "row mt-4" }, [
      _createElementVNode("h6", { class: "mb-2 text-uppercase pl-3" }, "Welche Maßnahme:")
    ], -1)),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.fcOperationType,
          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((formData.value.fcOperationType) = $event)),
          label: "FC",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.micOperationType,
          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((formData.value.micOperationType) = $event)),
          label: "MIC",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.compassOperationType,
          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((formData.value.compassOperationType) = $event)),
          label: "KOMPASS",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.goWorkOperationType,
          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((formData.value.goWorkOperationType) = $event)),
          label: "GoArbeit",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("div", _hoisted_25, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.othersOperationType,
          "onUpdate:modelValue": [
            _cache[17] || (_cache[17] = ($event: any) => ((formData.value.othersOperationType) = $event)),
            onChangeOthersOperationType
          ],
          label: "Andere",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_26, [
        _createVNode(BaseInput, {
          modelValue: formData.value.othersOperationTypeDescription,
          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((formData.value.othersOperationTypeDescription) = $event)),
          label: "Beschreibung",
          disabled: otherOperationTypeDisabled.value,
          validation: _unref(v$)?.othersOperationTypeDescription,
          messages: _unref(v$)?.othersOperationTypeDescription?.required?.$message
        }, null, 8, ["modelValue", "disabled", "validation", "messages"])
      ])
    ]),
    _cache[30] || (_cache[30] = _createElementVNode("div", { class: "row mt-4" }, [
      _createElementVNode("h6", { class: "mb-2 text-uppercase pl-3" }, "Welches Fachcoaching:")
    ], -1)),
    _createElementVNode("div", _hoisted_27, [
      _createElementVNode("div", _hoisted_28, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.specialistCoachingPsychologically,
          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((formData.value.specialistCoachingPsychologically) = $event)),
          label: "Psychologisch",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_29, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.specialistCoachingHealthWise,
          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((formData.value.specialistCoachingHealthWise) = $event)),
          label: "Gesundheitlich",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_30, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.specialistCoachingSocial,
          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((formData.value.specialistCoachingSocial) = $event)),
          label: "Sozial",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_31, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.specialistCoachingProfessionally,
          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((formData.value.specialistCoachingProfessionally) = $event)),
          label: "Beruflich",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _cache[31] || (_cache[31] = _createElementVNode("div", { class: "row mt-4" }, [
      _createElementVNode("h6", { class: "mb-2 text-uppercase pl-3" }, "Digitale Kompetenz/Endgeräte:")
    ], -1)),
    _createElementVNode("div", _hoisted_32, [
      _createElementVNode("div", _hoisted_33, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.digitalCompetenceSmartphone,
          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((formData.value.digitalCompetenceSmartphone) = $event)),
          label: "Smartphone",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_34, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.digitalCompetenceLaptopPc,
          "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((formData.value.digitalCompetenceLaptopPc) = $event)),
          label: "Laptop/PC",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_35, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.digitalCompetenceNoDeviceAvailable,
          "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((formData.value.digitalCompetenceNoDeviceAvailable) = $event)),
          label: "Kein Gerät",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_36, [
      _createElementVNode("div", _hoisted_37, [
        _createVNode(SaveButton, {
          label: _ctx.$t('general.button.save'),
          loading: isSubmitting.value
        }, null, 8, ["label", "loading"])
      ])
    ])
  ], 32))
}
}

})